import React, { useMemo } from 'react';
import { useProject } from '../../context/ProjectContext';
import SiteVisitAssignmentPanel from './SiteVisitAssignmentPanel';
import './SiteVisitAssignmentPage.css';

function resolveSessionProjectCode(projectInfo, currentProject) {
  const fromInfo = (projectInfo?.projectCode || projectInfo?.ProjectCode || '').toString().trim();
  if (fromInfo) return fromInfo;
  const cp = (currentProject || '').toString().trim();
  if (cp && cp !== 'all') return cp;
  return '';
}

/**
 * Standalone Skip Visit Management page (menu op 0623).
 * Uses session/header project; own APIs under /api/SiteVisitAssignment.
 */
const SiteVisitAssignmentPage = () => {
  const { projectInfo, currentProject } = useProject();
  const projectCode = useMemo(
    () => resolveSessionProjectCode(projectInfo, currentProject),
    [projectInfo, currentProject]
  );

  if (!projectCode) {
    return (
      <div className="sva-page">
        <p className="sva-empty">
          No project in session. Change project from Visit or Site pages (shown in the header).
        </p>
      </div>
    );
  }

  return (
    <div className="sva-page">
      <h1 className="sva-title">Skip Visit Management</h1>
      <SiteVisitAssignmentPanel key={projectCode} projectCode={projectCode} />
    </div>
  );
};

export default SiteVisitAssignmentPage;
